import { z } from "zod";
// =============================================================================
// DRAFT SCHEMAS
// =============================================================================
export const DraftBookingItemSchema = z.object({
    service_id: z.number().int().positive(),
    service_name: z.string().max(200),
    start_datetime: z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/),
    end_datetime: z.string().regex(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/),
    quantity_of_participants: z.number().int().min(1).max(500),
    custom_field_values: z.record(z.string(), z.union([z.string(), z.number(), z.boolean()])),
    notes: z.string().nullable().optional(),
});
export const DraftCustomerCandidateSchema = z.object({
    name: z.string().min(1).max(100),
    last_name: z.string().max(150).nullable().optional(),
    full_name: z.string().min(1).max(250),
});
export const ItineraryDraftSchema = z.object({
    type: z.literal("ITINERARY_DRAFT"),
    customer_id: z.number().int().positive().nullable(),
    customer_status: z.enum(["resolved", "needs_creation"]).optional(),
    customer_candidate: DraftCustomerCandidateSchema.nullable().optional(),
    booking_items: z.array(DraftBookingItemSchema).min(1),
    tags: z.array(z.number().int().positive()).max(50),
});
// =============================================================================
// REQUEST/RESPONSE SCHEMAS
// =============================================================================
export const ChatHistoryMessageSchema = z.object({
    id: z.string().min(1),
    role: z.enum(["user", "assistant"]),
    content: z.string().min(1).max(5000),
});
export const ChatRequestSchema = z.object({
    message: z.string().min(1).max(2000),
    locale: z.enum(["en", "es"]).optional(),
    conversationId: z.string().uuid().optional(),
    history: z.array(ChatHistoryMessageSchema).max(20).optional(),
});
export const ChatResponseSchema = z.object({
    message: z.string(),
    draft: ItineraryDraftSchema.nullable(),
    conversationId: z.string(),
});
